import React from 'react'
import RegistrationContainer from './RegistrationContainer'

const Registration = props => <RegistrationContainer {...props} />

export default Registration



// WEBPACK FOOTER //
// ./src/routes/Registration/index.js